import React from "react";
import CommonTopDetails from "../../../components/AdminComponents/CommonTopDetails";
import { Table } from "antd";
import { useNavigate, useLocation } from "react-router-dom";
import CaSideNav from "../../../components/AdminComponents/CaSideNav";
import Sidebar from "../../../components/AdminComponents/SideNav";
import {
  CourseTopLevel,
  CourseTopLevelCA,
} from "../../../components/AdminComponents/MenuItems";
import { Pagination } from "antd";
import useCommonListing from "../../../components/AdminComponents/customHooks/useCommonListing";
import { GetFormattedDateTime } from "../../../components/utils/DateTimeUtils";
const CourseQuizListing = () => {
  const navigate = useNavigate();
  const columns = [
    {
      title: "Quiz Name",
      dataIndex: "quiz_name",
      key: "quiz_name",
      width: 180,
      render: (text) => (
        <span style={{ color: "#1890ff" }}>
          {text}
        </span>
      ),
    },
    {
      title: "Course ID",
      dataIndex: "courses",
      key: "course_id",
      width: 120,
      render: (courses) => courses?.map((c) => c.course_id).join(", "),
    },
    {
      title: "Course Name",
      dataIndex: "courses",
      key: "courses_name",
      width: 200,
      render: (courses) => courses?.map((c) => c.name).join(", "),
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
      width: 250,
      ellipsis: true,
      render: (text) => text || "—",
    },
    {
      title: "Passing Score",
      dataIndex: "passing_score",
      key: "passing_score",
      width: 120,
      render: (score) => (score !== null && score !== undefined ? `${score}%` : "—"),
    },
    {
      title: "Created Date",
      dataIndex: "created_at",
      key: "created_at",
      width: 150,
      render: GetFormattedDateTime,
    },
    {
      title: "Updated Date",
      dataIndex: "updated_at",
      key: "updated_at",
      width: 150,
      render: GetFormattedDateTime,
    },
  ];

  const {
    data,
    itemsLength,
    loading,
    filterData,
    onShowSizeChange,
    onPageChange,
    handleSearchChange,
  } = useCommonListing({
    passSize: 10,
    passPage: 1,
    passURL: `/learn/quizlist/`,
  });

  const { pageSize, currentPage } = filterData;
  const location = useLocation();
  const isCAAdmin = location.pathname.includes("ca-admin");
  const WrapperComponent = isCAAdmin ? CaSideNav : Sidebar;
  const wrapperProps = isCAAdmin ? CourseTopLevelCA : CourseTopLevel;
  return (
    <WrapperComponent props={wrapperProps}>
      <CommonTopDetails
        title={`Quiz Management`}
        titleSuffix={`${itemsLength || 0} quiz(s)`}
        searchPlaceholder="Search by..."
        searchAction={handleSearchChange}
        showAddButton={true}
        filterAction={false}
        // marginPass="15px"
        paddingInlinepass="10px"
        // topSizeAdd="5px"
        addButtonProps={{
          modalType: "Redirect",
          redirctlink: "/trainery-learn/quiz/add",
        }}
      />
      <Table
        columns={columns}
        dataSource={data}
        rowKey="quiz_id"
        size="small"
        loading={loading}
        className="table-container"
        style={{ margin: "1rem" }}
        pagination={false}
        scroll={{
          x: 500,
        }}
        bordered
        onRow={(record) => ({
          onClick: () => navigate(`/trainery-learn/quiz/edit/${record.quiz_id}`),
          style: { cursor: "pointer" },
        })}
      />

      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          padding: "1rem",
        }}
      >
        <Pagination
          size="small"
          showSizeChanger
          onShowSizeChange={onShowSizeChange}
          onChange={onPageChange}
          pageSizeOptions={["5", "10", "15", "20", "50"]}
          current={currentPage}
          defaultPageSize={pageSize}
          total={itemsLength}
        />
      </div>
    </WrapperComponent>
  );
};

export default CourseQuizListing;
